import { Component, Input, Output, EventEmitter, SimpleChanges, OnInit, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder, FormGroup, UntypedFormControl, Validators, ValidatorFn } from '@angular/forms';
import { SchedDiscConfigComponentBase } from "../SchedDiscConfigComponentBase";
import { NetFacadeService } from 'netview';
import { ConfigurationService } from 'configuration';
import { GetSlackInfoResultDto } from 'UvExplorerServer.Dtos.TS/Tools';
import { MessageService } from 'base';
import { Observable, Subject } from 'rxjs';
import { HashSet } from 'DiscoveryEngine.TS/Utils';
import { ResultDto } from 'UvExplorerServer.Dtos.TS';

@Component({
    selector: 'sched-disc-config-events',
	templateUrl: './sched-disc-config-events.component.html',
	styleUrls: ['./sched-disc-config-events.component.scss']
})
export class SchedDiscConfigEventsComponent extends SchedDiscConfigComponentBase implements OnInit {

	public LogEvents: UntypedFormControl;
	public EmailEvents: UntypedFormControl;
	public EmailRecipients: UntypedFormControl;
	public IncludeSystemRecipients: UntypedFormControl;
	public EmailEventsOnChangesOnly: UntypedFormControl;
	public AttachAssetsReport: UntypedFormControl;
	public AttachDeviceConnectivityReport: UntypedFormControl;
	public SystemRecipients: UntypedFormControl;
	public SlackEvents: UntypedFormControl;
	public SlackEventsOnChangesOnly: UntypedFormControl;
	public SlackWebhooks: UntypedFormControl;

	private _SystemEmailRecipients: string = "";
	public IsEmailConfigured: boolean = false;

	constructor(private fb: UntypedFormBuilder, 
		netFacadeService: NetFacadeService,
		private configService: ConfigurationService,
		private messageService: MessageService) {
		
		super(netFacadeService);
	}

	private GetSmtpConfiguration(): void {

		this.IsEmailConfigured = false;
		this._SystemEmailRecipients = "";

		if (this.Network && this.Network.HasSmtpSettings && this.Network.SmtpSettings.IsValid) {
			this.IsEmailConfigured = true;
			this._SystemEmailRecipients = this.Network.SmtpSettings.ToAddress;
		}
	}

	protected BuildForm(): void {
		let logEvents = false;
		let emailEvents = false;
		let emailRecipients = "";
		let includeSystemRecipients = false;
		let emailEventsOnChangesOnly = false;
		let attachAssetsReport = false;
		let attachDeviceConnectivityReport = false;
		let systemRecipients = "";
		let slackEvents = false;
		let slackEventsOnChangeOnly = false;
		let slackWebhooks = "";

		if (this.Discovery) {
			logEvents = this.Discovery.LogEvents;
			emailEvents = this.Discovery.EmailEvents;
			emailRecipients = this.Discovery.EmailRecipients;
			includeSystemRecipients = this.Discovery.EmailSystemRecipients;
			emailEventsOnChangesOnly = this.Discovery.EmailEventsOnChangesOnly;
			attachAssetsReport = this.Discovery.AttachAssetsReport;
			attachDeviceConnectivityReport = this.Discovery.AttachDeviceConnectivtyReport;
			systemRecipients = this._SystemEmailRecipients;
			slackEvents = this.Discovery.SlackEvents;
			slackEventsOnChangeOnly = this.Discovery.SlackEventsOnChangesOnly;
			slackWebhooks = this.Discovery.SlackWebhooks;
		}

		this.LogEvents = new UntypedFormControl(logEvents);
		this.EmailEvents = new UntypedFormControl(emailEvents);
		this.EmailRecipients = new UntypedFormControl(emailRecipients);
		this.IncludeSystemRecipients = new UntypedFormControl(includeSystemRecipients);
		this.EmailEventsOnChangesOnly = new UntypedFormControl(emailEventsOnChangesOnly);
		this.AttachAssetsReport = new UntypedFormControl(attachAssetsReport);
		this.AttachDeviceConnectivityReport = new UntypedFormControl(attachDeviceConnectivityReport);
		this.SystemRecipients = new UntypedFormControl(systemRecipients);
		this.SlackEvents = new UntypedFormControl(slackEvents);
		this.SlackEventsOnChangesOnly = new UntypedFormControl(slackEventsOnChangeOnly);
		this.SlackWebhooks = new UntypedFormControl(slackWebhooks);

		this.enableDisableControls();

		this.SettingsForm = this.fb.group({
			LogEvents: this.LogEvents,
			EmailEvents: this.EmailEvents,
			EmailRecipients: this.EmailRecipients,
			IncludeSystemRecipients: this.IncludeSystemRecipients,
			EmailEventsOnChangesOnly: this.EmailEventsOnChangesOnly,
			AttachAssetsReport: this.AttachAssetsReport,
			AttachDeviceConnectivityReport: this.AttachDeviceConnectivityReport,
			SystemRecipients: this.SystemRecipients,
			SlackEvents: this.SlackEvents,
			SlackEventsOnChangesOnly: this.SlackEventsOnChangesOnly,
			SlackWebhooks: this.SlackWebhooks,
		});
	}

	public ngOnInit(): void {

	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.onChanges();
		this.GetSmtpConfiguration();
		this.BuildForm();
	}

	public applyTempChanges(): void {
		if (this.Discovery) {
			this.Discovery.LogEvents = this.LogEvents.value;
			this.Discovery.EmailEvents = this.EmailEvents.value;
			this.Discovery.EmailRecipients = this.EmailRecipients.value;
			this.Discovery.EmailSystemRecipients = this.IncludeSystemRecipients.value;
			this.Discovery.EmailEventsOnChangesOnly = this.EmailEventsOnChangesOnly.value;
			this.Discovery.AttachAssetsReport = this.AttachAssetsReport.value;
			this.Discovery.AttachDeviceConnectivtyReport = this.AttachDeviceConnectivityReport.value;
			this.Discovery.SlackEvents = this.SlackEvents.value;
			this.Discovery.SlackEventsOnChangesOnly = this.SlackEventsOnChangesOnly.value;
			this.Discovery.SlackWebhooks = this.SlackWebhooks.value;
				
			this.BuildForm();
			this.onApplyTempChanges();
		}
	}

	public get invalidTempChanges(): string[] {
		return ["Events"];
	}

	public get enableTestSlackButton(): boolean {
		return (!!this.SlackEvents && this.SlackEvents.value && !!this.SlackWebhooks && this.SlackWebhooks.value);
	}

	public enableDisableControls(): void {
		this.SystemRecipients.disable();

		if (this.EmailEvents.value) {
			this.EmailRecipients.enable();
			this.IncludeSystemRecipients.enable();
			this.EmailEventsOnChangesOnly.enable();
			this.AttachAssetsReport.enable();
			this.AttachDeviceConnectivityReport.enable();
		}
		else {
			this.EmailRecipients.disable();
			this.IncludeSystemRecipients.disable();
			this.EmailEventsOnChangesOnly.disable();
			this.AttachAssetsReport.disable();
			this.AttachDeviceConnectivityReport.disable();
		}

		if (this.SlackEvents.value) {
			this.SlackEventsOnChangesOnly.enable();
			this.SlackWebhooks.enable();
		}
		else {
			this.SlackEventsOnChangesOnly.disable();
			this.SlackWebhooks.disable();
		}
	}

	public testSlack(): void {
		this.configService.testSlackConnection(this.SlackWebhooks.value).subscribe(
			() => {
				this.messageService.displayInfoMessage("Successfully sent message to all channel webhooks.");
			},
			(error) => {
				this.messageService.displayErrorMessage(error);
			});
	}

}
